export default __webpack_public_path__ + "static/media/telus_logo.54fd8a97.png";